var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1060_684",
    transform: "scale(0.025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1060_684",
    width: 40,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsSAAALEgHS3X78AAACpElEQVRYhc2ZQXLaMBSG3+8TsGs7YQFlUoY0TZ1NS7LB3CA3oTdguAHchBvUbAjtJmpIIZRJwyKZaXfc4HWeMC7YMoEEjLTggZCfPv9Pkq0n0DPK5O4uByKPgAqIXAJccQRAPkg7nVlFgAJRhwD/TTY72bS3jQB/j8cegBqILiIgoTVAzupmtk1ErdfZrL9VwLvRSNSqB6rpDk1wa0KK8QE0Xh0cPAm6EnB8e5shojqALzGQl0OKbRKRgE43Bvw1HArcVwDu3OmOIBURVZMgjYCjwcAN4DIRZ7uCnAaQ6knA4c1NBsC9CS4FyHxUSWfxx6Df12Fl5gwz6zqT5dmX/9ZUt2C1D1PdstV9/318zCQCyoRgZjcESR9S+q4bQ/zz+toLxl08pIa6HYe7Ol+CQgWZuZ5wV/tQMlRRA/aV8lgW4eQL0ob0/jw8eCEgM9fWuKu0IWs63D+uruTBf0/rj4/UxiQBeYeYvSVyi5QUNoeZKzEQSyCZqOKwvM+ZQCyAJGZXQuwmguwf0nUSG1oC6SRdYAukk+jEEkhnpRMLIB2KOLUNUiaJshhSiYJqsaFlkEoU7EQbWgTZkVnsmxpaAuk7n8rlCTO3LYRs5wqFyfyNupXUcI+QLZov1J/Pznwdansg/beHh7E9SWOV5ClDNuZcIWD5/FwUbFoA2SwUi34MMCgNZlZ7hJS+G4tAsdRHr9uVnf1S6sO0z0j8L7pXWX+PMwWQf1cqJac+glDrRA4zT1NUUvcZhTMCBpAidT6lcCtmzhePjmKZrUTAiJK7nDhNZq6Wjo83T2Aull63K7lpSUd4WxqTOgX8/uTkZSngaPl2eSnpiBqAi2dCtgG0PrjudpPo0fK918tpNYkqwRGEHEWYIOUIQgHQxxAfT083O4Ygon8KmALGKdePGQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverGold);
export default __webpack_public_path__ + "static/media/silver-gold.21d168abaa52c5140cb17d7e1a0bb0c8.svg";
export { ForwardRef as ReactComponent };